export const CustomerState = {
	url: '/customer/:consultationId',
	title: 'Customer Page',
	template: '<customer-page></customer-page>',
	params: {
		consultationId: {
			type: 'path',
			squash: true,
		},
	},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "customerUpdatePageMod" */
			'@Containers/builder-customer-page/customer-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
	resolve: [
		{
			token: 'canView',
			policy: {when: 'EAGER'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (RoutesSvc, trans) =>
				RoutesSvc.validateConsultationPrivate({status: 'draft', ...trans.params()}).catch(state =>
					trans.router.stateService.go(state.name, state.params)
				),
		},
	],
};

export const CustomerCreateState = {
	url: '/create',
	title: 'Customer Page',
	template: '<customer-page></customer-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "customerCreatePageMod" */
			'@Containers/builder-customer-page/customer-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
